/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
import React, { useEffect }  from "react";

import { useNavigate } from 'react-router-dom';
// import TableSection from './TableSection';
//import PolicyStatusSort from './sms/view/TablePolicytStatusSorting'

import { FormJSONCreateContext } from "../FormJSONCreateContext";

import PolicyImg    from "../PolicyImg";
// import useStyles    from '../Theme_1/ComponentCss';
import ThemeControls from "../AllThemesControl";
import SuccessPage  from '../SuccessPage';
import Dialog from '@mui/material/Dialog'; 
import ScrubSuccessPage  from '../ScrubSuccessPage';
import FormSection  from "../../FormsControls/FormSection";
// import ProcurementCoustom from '../../modules/Procurement/CoustomCreate';
// import QualityCheckCoustom from '../../modules/QualityCheck/CoustomCreate';

function FormScopeDefiner(obj) {
    const {useStyles} = ThemeControls;
    const apiContextObj = obj.value.apiContextObj;
    const setSubResponse = obj.value.setSubResponse;
    const id = obj.value.id;
    const contextId = obj.value.contextId;
    const apiString = obj.apiString;
    const setLoading = obj.value.setLoading;
    const apiContext = obj.value.apiContext;
    const Close =obj.value.close;
    const editData = obj.value.editData;
    const setEditData = obj.value.setEditData;
    const searchListPage =  obj.value.searchListPage;
    const contextJson = obj.value.contextJson;
    const contextObjective = obj.value.contextObjective;
    const Heading = obj.value.contextHeading;
    const contextClasses = obj.value.contextClasses;
    const contextIndex = obj.value.contextIndex;
    const contextDataArr = obj.value.contextDataArr;
    const [successRender,setSuccessRender] = React.useState(undefined);
    const [successPageData,setSuccessPageData] = React.useState(undefined);
    const [open,setOpen] = React.useState(false);
    const classes=useStyles();
    // const { handleClose } = React.useContext(FormJSONCreateContext);
   //for navigation 
    let navigate = useNavigate();

    function ResetFormData(contextJson){
      console.log(contextJson)
      Object.keys(contextJson).forEach((key, index) => {
        if (key !== "xioFEConfig") {
          contextJson[key].fields.map((field) => {
            if(field.field_type==="hidden"){
              if(field.field_default_value){
                field.field_value = field.field_default_value
                field.id = field.id;
              }else{
                field.field_value = field.field_value;
                field.id = field.id;
              }
            }else if (field.field_default_value) {
              field.field_value = field.field_default_value
              field.id = ""
            }else if(field.field_type==='nestedRender'){
              Object.keys(field.field_context).forEach((key, index) => {
                // ////console.log(key)
                if (key !== "xioFEConfig") {
                  field.field_context[key].fields.map((field) => {
                    if (field.field_default_value) {
                      field.field_value = field.field_default_value
                      field.id = ""
                    }else{
                      field.field_value = "";
                      field.id = "";
                    }
                  });
                }
              });
            } else {
              field.field_value = "";
              field.field_temp_value = "";
              field.id = "";
              field.field_helperText = "";
            }
            return field;
          });
        }
      });
    }
  
  //On Success Create Policy....>
    function renderSuccessPage(props){
      setSuccessPageData(props);
      setSuccessRender(1);
      //console.log('Success Render is Rendering...') 
  
    }
    function navigateToCreate(){
      ResetFormData(contextJson)
      navigate(successPageData.createLink)
      setSuccessRender(undefined);
      return null;
    }

    function navigateToView(){
       
      navigate(successPageData.viewLink);
    }
    
    useEffect(()=>{
      Object.keys(contextJson).forEach((key,index)=>{
        if(key!=="xioFEConfig"){
         // Object.keys(contextJson[key]).forEach((_key,_index)=>{
            for(let i=0;i<(contextJson[key].fields).length;++i){
              if(contextJson[key].fields[i].field_type === "formIO"){
                if(localStorage.getItem(contextJson[key].fields[i].field_id)){
                  localStorage.removeItem(contextJson[key].fields[i].field_id);
                }
                if(typeof(contextJson[key].fields[i].field_value) === "string" && contextJson[key].fields[i].field_value!== "" ){
                  localStorage.setItem(contextJson[key].fields[i].field_id,JSON.stringify(JSON.parse(contextJson[key].fields[i].field_value)));
                }else{
                  localStorage.setItem(contextJson[key].fields[i].field_id, JSON.stringify(contextJson[key].fields[i].field_value) );

                }
              }
            }
        }
      })
    })

   
    return (
      <FormJSONCreateContext.Provider value={{renderSuccessPage,setSubResponse,contextId,id,apiString,editData,setEditData,searchListPage,Close,contextJson,apiContextObj,apiContext,contextClasses,contextObjective,contextIndex,contextDataArr,setLoading}}>

       <Dialog className={classes.SuccessPopup}
              open={open}
              aria-labelledby="responsive-dialog-title">
                  {successPageData&&(<ScrubSuccessPage  
                  open={open}
                  successPageData={successPageData}
                   createPolicyLink = {navigateToCreate}
                   viewPolicyLink = {navigateToView}
                  //  close={myFunction()}
                  //  close={()=>(myFunction())}
                   createButtonText = {successPageData.createButtonText}
                   viewButtonText = {successPageData.viewButtonText}
                   dataRecevied = {successPageData.dataRecevied}
                  />)}
        </Dialog>
        {(successRender&&successPageData)?
          <SuccessPage
            flowName ={successPageData.flowName}
            actionName = {successPageData.actionName}
            createPolicyLink = {navigateToCreate}
            viewPolicyLink = {navigateToView}
            close={Close}
            createButtonText = {successPageData.createButtonText}
            viewButtonText = {successPageData.viewButtonText}
            paragraphText = {successPageData.paragraphText}
          />
        :
          <FormSection Heading={Heading} contextClasses={contextClasses} contextObjective={contextObjective}/>
        }
        {/* {componentToRender} */}
      </FormJSONCreateContext.Provider>
    );
  }
  
  export default FormScopeDefiner;
  